(function () {
  'use strict';
  function init() {
    var grid = document.querySelector('[data-lkc-filter-trial="true"]');
    if (!grid) return;
    var instance = window.theme && window.theme.CollectionFilter;
    if (instance && instance.selector && instance.selector.collection_grid_container === grid) {
      instance.sectionId = 'lkc-filter-eager';
    }
    var root = grid.querySelector('[data-lkc-deferred-filters]');
    if (!root) return;
    var state = 'idle';
    var controller;
    var timer;
    var status = root.querySelector('[data-lkc-filter-status]');
    var loadingText = status.textContent;
    var errorBox = root.querySelector('[data-lkc-filter-error]');
    var skeleton = root.querySelector('.lkc-filter-skeleton');
    var requestedUrl;
    var observer;
    function fallbackUrl() {
      var url = new URL(window.location.href);
      url.searchParams.delete('section_id');
      url.searchParams.delete('sections');
      url.searchParams.set('view', 'lkc-release-full');
      return url;
    }
    root.querySelector('[data-lkc-filter-fallback]').href = fallbackUrl().href;
    function current() {
      return root.isConnected && grid.querySelector('[data-lkc-deferred-filters]') === root && requestedUrl === window.location.pathname + window.location.search;
    }
    async function load() {
      if (state === 'loading' || state === 'ready' || !root.isConnected) return;
      state = 'loading';
      requestedUrl = window.location.pathname + window.location.search;
      errorBox.hidden = true;
      skeleton.hidden = false;
      status.textContent = loadingText;
      root.setAttribute('aria-busy', 'true');
      grid.dataset.lkcFilterStartedMs = String(Math.round(performance.now()));
      controller = new AbortController();
      timer = setTimeout(function () { controller.abort(); }, 12000);
      try {
        var url = new URL(window.location.href);
        url.searchParams.delete('sections');
        url.searchParams.set('section_id', root.dataset.filterSection);
        var response = await fetch(url.href, { signal: controller.signal, credentials: 'same-origin' });
        if (!response.ok) throw new Error('Filter response failed');
        var html = await response.text();
        if (!current()) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fragment = doc.querySelector('[data-lkc-filter-response]');
        var tree = fragment && fragment.querySelector('#gf-tree');
        var count = fragment && fragment.querySelector('template[data-lkc-filter-count]');
        var chips = fragment && fragment.querySelector('template[data-lkc-filter-chips]');
        if (!tree || !count || !chips || !tree.querySelector('.gf-filter-contents')) throw new Error('Filter response incomplete');
        root.replaceWith(tree);
        grid.querySelectorAll('[data-lkc-filter-count-slot]').forEach(function (slot) { slot.innerHTML = count.innerHTML; });
        var chipSlot = grid.querySelector('[data-lkc-filter-chips-slot]');
        if (chipSlot) chipSlot.innerHTML = chips.innerHTML;
        if (instance && instance.state) {
          var min = tree.querySelector('.gf-range-min');
          var max = tree.querySelector('.gf-range-max');
          instance.state.minPriceRangePreviousValue = min ? parseInt(min.value, 10) : 0;
          instance.state.maxPriceRangePreviousValue = max ? parseInt(max.value, 10) : 0;
        }
        state = 'ready';
        observer.disconnect();
        grid.removeEventListener('pointerdown', warm, true);
        grid.removeEventListener('focusin', warm);
        if (mobile.removeEventListener) mobile.removeEventListener('change', screenChanged);
        else if (mobile.removeListener) mobile.removeListener(screenChanged);
        grid.dataset.lkcFilterReadyMs = String(Math.round(performance.now()));
        grid.dataset.lkcFilterState = 'ready';
      } catch (error) {
        if (!current()) return;
        state = 'error';
        status.textContent = '';
        errorBox.hidden = false;
        skeleton.hidden = true;
        root.removeAttribute('aria-busy');
        grid.dataset.lkcFilterState = 'error';
        root.querySelector('[data-lkc-filter-fallback]').href = fallbackUrl().href;
      } finally {
        clearTimeout(timer);
      }
    }
    grid.addEventListener('click', function (event) {
      if (event.target.closest('[data-lkc-filter-retry]') || event.target.closest('.gf-refine-toggle-mobile')) load();
    }, true);
    root.querySelector('.gf-close-canvas').addEventListener('keydown', function (event) {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        document.body.classList.remove('offcanvas-open');
      }
    });
    observer = new MutationObserver(function () {
      if (!root.isConnected && controller) {
        controller.abort();
        observer.disconnect();
      }
    });
    observer.observe(grid, { childList: true, subtree: true });
    function begin() {
      requestAnimationFrame(function () { requestAnimationFrame(load); });
    }
    var mobile = window.matchMedia('(max-width: 1023px)');
    var filterTrigger = '.gf-refine-toggle-mobile';
    function warm(event) {
      if (event.target.closest(filterTrigger)) load();
    }
    function screenChanged(event) {
      if (!event.matches) begin();
    }
    grid.addEventListener('pointerdown', warm, { passive: true, capture: true });
    grid.addEventListener('focusin', warm);
    if (mobile.addEventListener) mobile.addEventListener('change', screenChanged);
    else if (mobile.addListener) mobile.addListener(screenChanged);
    if (mobile.matches) {
      grid.dataset.lkcFilterState = 'waiting-for-open';
      if (document.body.classList.contains('offcanvas-open')) load();
      return;
    }
    var image = grid.querySelector('img.spf-product-card__image-main');
    var hasFilter = Array.from(new URLSearchParams(window.location.search).keys()).some(function (key) { return key.indexOf('filter.') === 0; });
    if (hasFilter || !image || image.complete) begin();
    else {
      image.addEventListener('load', begin, { once: true });
      image.addEventListener('error', begin, { once: true });
      setTimeout(begin, 600);
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
